<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="v3-loading-container">
  <div class="v3-loading-logo">
    <img
      src="https://static.yuna.potential.ly/public/images/icons/potentially_logo.png"
      [alt]="'translations.global.label.potentiallyLogoAlt' | transloco"
      width="60"
      height="61"
    />
    <span class="section-title">{{ 'translations.public.lti.title.logoText' | transloco }}</span>
  </div>
  <div class="v3-loading-in-progress">
    <span class="fs-body-m">{{ 'translations.loginFormLoading.loading' | transloco }}</span>
    <mat-spinner [diameter]="25"></mat-spinner>
  </div>
  <div class="v3-loading-warning fs-body-s bold">{{ 'translations.loginFormLoading.loadingTooLongWarning' | transloco }}</div>
</div>
